__turbopack_context__.v({
  "cat": "NJI3kW_cat",
  "catActive": "NJI3kW_catActive",
  "catRow": "NJI3kW_catRow",
  "empty": "NJI3kW_empty",
  "feed": "NJI3kW_feed",
  "feedScrollers": "NJI3kW_feedScrollers",
  "filterActions": "NJI3kW_filterActions",
  "filterBar": "NJI3kW_filterBar",
  "headerActions": "NJI3kW_headerActions",
  "layout": "NJI3kW_layout",
  "main": "NJI3kW_main",
  "mobileSearchRow": "NJI3kW_mobileSearchRow",
  "showAll": "NJI3kW_showAll",
  "topStories": "NJI3kW_topStories",
  "topicChip": "NJI3kW_topicChip",
  "topicChipClear": "NJI3kW_topicChipClear",
  "topicChipLabel": "NJI3kW_topicChipLabel",
  "topicCount": "NJI3kW_topicCount",
  "topicScope": "NJI3kW_topicScope",
  "typeMobile": "NJI3kW_typeMobile",
  "unreadBadge": "NJI3kW_unreadBadge",
});
